import { render, staticRenderFns } from "./ConfirmDownload.vue?vue&type=template&id=4532c6b2"
import script from "./ConfirmDownload.vue?vue&type=script&lang=js"
export * from "./ConfirmDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports